import React, { useEffect, useContext } from 'react';
import useRestaurant from 'hooks/useRestaurant';
import RestaurantRoutes from './routes';
import { HumanSpeaker } from 'util/speaker';
import { useStore } from 'store';
import { AuthContext } from 'fbase/authContext';

const RestaurantDashboard = () => {
  const {
    state: { notify }
  } = useStore();

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    const interval = setInterval(() => {
      if (notify) {
        HumanSpeaker.speak(notify);
      }
    }, 30000);

    if (!currentUser) {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [currentUser, notify]);

  const isValid = useRestaurant();

  if (isValid) {
    return <RestaurantRoutes />;
  }

  return null;
};

export default RestaurantDashboard;
